import { render, staticRenderFns } from "./AddressListLeft.vue?vue&type=template&id=1d28f146&scoped=true"
import script from "./AddressListLeft.vue?vue&type=script&lang=js"
export * from "./AddressListLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d28f146",
  null
  
)

export default component.exports